import { DAYTOOL } from "../classes/daytool.js";
import { daytool_need } from "../classes/daytool_entity.js";
import { daytool_injector } from "../classes/UI/daytool_injector.js";

export function loadSleepBasicPresets() {
  // SLEEP
  var sleep = new daytool_need();
  sleep.title.push("Sleep");
  sleep.icon.push("sleep");
  sleep.imported = true;
  sleep.description.push("Set aside time to make sure you get enough sleep.");
  DAYTOOL.addEntity(sleep);
  // SLEEP GOAL SUGGESTIONS
  // 1. Trying to keep as close to circadian rhythm as possible - timing substance intake and waking with the Sun as much as possible
  // 2. Pre-sleep and post-sleep rituals
  // 3. Making bed clean and comfortable, and not hurting the spinal column

  // SLEEP SITUATIONAL GOALS SUGGESTION
  // 1. (Pre-professional) Apprenticeships
  // 2. (Young Professional) Finding key mentors
  // 3. (Older Professionals) Mentoring

  // COMMON SLEEP RELATED ISSUES:
  // 1.
}
